import { _ } from "src/services";
import { ShareSocials } from "./share.socials";

export const ShareInline: React.FC<{ title?: string }> = ({ title }) => {

    const location = window.location.href;
    const shareTitle = _("shareTitle").replaceAll("{title}", title || "");

    return (
        <ul className="share-links fixed-links d-flex list-unstyled p-0 mb-0">
            {ShareSocials.map(({ url, icon, title }, index) => (
                <li className="ml-sm-1" key={index}>
                    <a href={url(location, shareTitle)} className="actions" title={title()} target="_blank" rel="noopener noreferrer">
                        <span className="center-item">
                            {icon()}
                        </span>
                    </a>
                </li>
            ))}
        </ul>
    );

};